export default {
    methods: {
      validateLength(value, length) {
        return value.length < length;
      },
      validateText(value) {
        return this.validateLength(value, 3);
      },
      validateEmail: function (value) {
        return !(/(.+)@(.+){2,}\.(.+){2,}/.test(value));
      },
      validatePhone: function (value) {
        var reg = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g;
        return !(reg.test(value) && value.length <= 13 && value.length >= 7);
      },
      validatePhone2: function (value) {
        var reg = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g;
        return !(reg.test(value) && value.length <= 9 && value.length >= 9);
      },
      validateOldPass: function (value1,value2) {
        if (value1 != value2) {
          return true;
        } else {
          return false;
        }
      },
      validateNewPass: function (value) {
        return this.validateLength(value, 6);
      },
      validateConfPass: function (value, confirmation) {
        return value != confirmation;
      },
      validateNone: function (value) {
        if(value === '' || value === null){
          return true;
        }else{
          return false;
        }
        
      },
      validateCheckboxList: function (val1, val2, val3) {
        if (!val1 && !val2 && !val3) {
          return true;
        } else {
          return false;
        }
      },
      validateId(value) {
        const digits_only = string => [...string].every(c => '0123456789'.includes(c));
        if( value.length == 11 && digits_only(value)){
          return false
        }else{
          return true
        }
      },
    },
  };
  